import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";

import SponsorshipLabel from "./SponsorshipLabel";
import { useSelector, useDispatch } from "react-redux";
import { VideoNote } from "../../../Shared/Notes/Notes";
import { updateParams } from "../../Product/productActions";
import Like from "../../../assets/images/vyrill/products/Like.png";
import Views from "../../../assets/images/vyrill/products/Views.png";
import Comments from "../../../assets/images/vyrill/products/Comments.png";
import {
  addDefaultSrc,
  capitalize as capitalizeString,
  abbreviateNumber,
} from "../../../utilities";

const VideoCardDetail = ({ item, videoProducts, note }) => {
  const defaultCreator =
    require("@src/assets/images/vyrill/Creator_Profile_Avatar.png").default;
  const navigate = useNavigate();
  const tab = useSelector((state) => state.videoParams.tab);
  const dispatch = useDispatch();

  const redirectTo = (url) => navigate(url);

  const linkName = (length, index, name) => {
    if (length === 1 && name.length < 17) {
      return name;
    }
    if (length === 1 && name.length > 17) {
      return `${name.substring(0, 20)}...`;
    }
    if (length > 1 && !index && name.length > 11) {
      return `${name.substring(0, 11)}...`;
    }
    return ` | ${name.substring(0, 11)}...`;
  };

  const productOrHashtag = (prods) => {
    const filteredProds = prods.filter((i) => i.name);
    return filteredProds.map((i, idx) => (
      <span
        key={uuidv4()}
        role="button"
        onClick={(e) => {
          e.stopPropagation();
          redirectTo(`/products/${i._id}`);
          dispatch(updateParams({ tab }));
        }}
      >
        {linkName(filteredProds.length, idx, i.name)}
      </span>
    ));
  };

  const videoStats = (
    <div className="video-stats">
      <div>
        <img src={Like} width={10} />
        <span className="stats-item">{abbreviateNumber(item.likes || 0)}</span>
      </div>
      <div>
        <img src={Views} width={15} />
        <span className="stats-item">
          {abbreviateNumber(item.view_count || 0)}
        </span>
      </div>
      <div>
        <img src={Comments} width={14} />
        <span className="stats-item">
          {abbreviateNumber(item.comment_count || 0)}
        </span>
      </div>
    </div>
  );

  const videoUploadDate = moment.utc(item?.created_at).format("ll");

  const authorImage = (
    <span>
      <img
        src={item?.influencer_detail?.author_img || defaultCreator}
        className="video-author-image"
        onError={(event) => addDefaultSrc(event, defaultCreator)}
      />
      <div className="d-flex justify-content-center">
        <p className="video-author-name text-capitalize">
          {item.author ||
            item.author_name_provided_by_brand_manager ||
            "Creator"}
        </p>
      </div>
    </span>
  );

  return (
    <div className="video-user-detail">
      <div className="user-detail">
        {authorImage}
        <SponsorshipLabel sponsorship={item?.sponsored} />
      </div>
      <div className="video-detail">
        <p className="video-title-para text-capitalize">
          {item.title ? (
            capitalizeString(item.title)
          ) : (
            <span className="no-text">
              Add a title to this video for easy identification
            </span>
          )}
        </p>
        <p className="topic-para">
          {(videoProducts?.length && productOrHashtag(videoProducts)) ||
            "Not assigned to a product"}
        </p>
        {item.upload_method !== "Vyrill_API" && videoStats}
        <div
          className={`${
            item.upload_method === "Vyrill_API"
              ? "video-footer-API"
              : "video-footer"
          }`}
        >
          <div className="date-field">{videoUploadDate}</div>
          <div onClick={(e) => e.stopPropagation()}>
            <VideoNote note={note} id={item._id} is_index isFlagWithReason />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCardDetail;
